import { useState } from "react"
import { TIMELINE, timelineData } from "../consts"
import moment from "moment";

const useOwnershipHistory = () => {
  const [activeTab, setActiveTab] = useState<"timeline" | "table">(TIMELINE);
  const updatedTimeline = timelineData?.map((data: any) => ({...data, desc: `${data.from} - ${data.to}`}))

  const onTabChange = (tab: "timeline" | "table") => {
    setActiveTab(tab);
  }

  const columns = [
    {
      accessorKey: "name",
      header: "Owner",
      accessorFn: (row: any) => String(row.name || ""),
    },
    {
      accessorKey: "from",
      header: "From",
      accessorFn: (row: any) => moment(row.from).format("MM/DD/YYYY"),
    },
    {
      accessorKey: "to",
      header: "To",
      accessorFn: (row: any) => moment.isDate(row.to) ? moment(row.to).format("MM/DD/YYYY") : row?.to || "",
    },
  ];

  return {
    updatedTimeline,
    onTabChange,
    activeTab,
    columns
  }
}

export default useOwnershipHistory;